var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-box"},[_c('div',{staticClass:"header"},[_c('img',{staticClass:"md:w-[221px] w-[130px] aspect-[221/76]",attrs:{"src":"/images/jhma-header-logo.png","alt":"JHMA"}})])])
}]

export { render, staticRenderFns }